import { API } from 'app/routes';
import axios from 'axios';
import { Action, action, Thunk, thunk } from 'easy-peasy';
import { FilterTaskPayload, MachineOppgaver, TaskFilterOptions, TaskPayload } from 'types/index';
import { StoreModel } from '~/store';

export interface TasksModel {
    fetching: boolean
    setFetching: Action<TasksModel, boolean>
    fetch: Thunk<TasksModel, TaskPayload, void, StoreModel, Promise<MachineOppgaver[]>>
    filters: FilterTaskPayload
    setFilters: Action<TasksModel, FilterTaskPayload>
    filterOptions: TaskFilterOptions
    setFilterOptions: Action<TasksModel, TaskFilterOptions>
    fetchFilterOptions: Thunk<TasksModel, number, void, StoreModel, Promise<void>>
}

export const tasksModel: TasksModel = {
    fetching: false,
    setFetching: action((state, payload) => {
        state.fetching = payload;
    }),
    fetch: thunk((actions, payload) => {
        actions.setFetching(true);
        return axios.post<null, MachineOppgaver[]>(`${API.tasks}`, payload)
            .then(data => data)
            .finally(() => {
                actions.setFetching(false);
            });
    }),
    filters: {
        departments: [],
        projects: [],
        responsible: [],
        searchText: ""
    },
    setFilters: action((state, payload) => {
        state.filters = payload;
    }),
    filterOptions: {
        departments: [],
        projects: []
    },
    setFilterOptions: action((state, payload) => {
        state.filterOptions = payload;
    }),
    fetchFilterOptions: thunk((actions, payload) => {
        actions.setFetching(true);
        return axios.get<null, TaskFilterOptions>(`${API.tasks}/filters/${payload}`)
            .then(data => actions.setFilterOptions(data))
            .finally(() => {
                actions.setFetching(false);
            });
    })
};
